const header_operlay = document.querySelector("[data-banner-header-overlay]");
if(header_operlay){
  document.body.classList.add('header-overlay');
}

//blog slider
const blog_swiper = new Swiper(".custom-main-blogs-section", {
  loop: true,
  speed: 1000,
  navigation: {
    nextEl: '.desk_slider_btn .swiper-button-next',
    prevEl: '.desk_slider_btn .swiper-button-prev'
  },
   keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  allowTouchMove: true,
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 0 },
    380: { slidesPerView: 1, spaceBetween: 0 },
    740: { slidesPerView: 2, spaceBetween: 30 },
    999: { slidesPerView: 3, spaceBetween: 30 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
  },
});

// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      const isOpen = accordion.classList.contains("is-open");
      document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
        item.classList.remove("is-open");
        const content = item.nextElementSibling;
        if (content) content.style.maxHeight = "0px";
      });
      if (!isOpen) {
        accordion.classList.add("is-open");
        const content = accordion.nextElementSibling;
        if (content) content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});

// -------------- faq page  js
const faqtitle = document.querySelectorAll('.faq-btn');
faqtitle.forEach(faqtitles => {
  faqtitles.addEventListener('click', function (event) {
    event.preventDefault();

    const gettitle = this.getAttribute('data-btn-title');
    faqtitle.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');


    document.querySelectorAll('.faq-page-content').forEach(content => {
      content.style.display = "none";
    });

    const contentdiv = document.querySelector(`.faq-page-content[data-faq-content="${gettitle}"]`);

    if (contentdiv) {
      contentdiv.style.display = "block";
    }
   const classremove  =  document.querySelector('.dropdown-content');
    classremove.classList.remove('dropdown-active')
  });
});

document.querySelectorAll('.dropdown-button').forEach(dropdownBtn => {
  dropdownBtn.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevents immediate closing when clicking button

    const closestDiv = this.closest('.dropdown');
    const dropdownContent = closestDiv.querySelector('.dropdown-content');

    // Close all other dropdowns
    document.querySelectorAll('.dropdown-content').forEach(content => {
      if (content !== dropdownContent) {
        content.classList.remove('dropdown-active');
      }
    });

    dropdownContent.classList.toggle('dropdown-active');
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.dropdown-content').forEach(content => {
    if (!content.closest('.dropdown').contains(event.target)) {
      content.classList.remove('dropdown-active');
    }
  });
});

function toggleDropdown() {
  var dropdownMenu = document.getElementById("dropdownMenu");
  var dropdownIcon = document.getElementById("right-arrow");

  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none";
    dropdownIcon.style.transform = "rotate(0deg)";
  } else {
    dropdownMenu.style.display = "block";
    dropdownIcon.style.transform = "rotate(180deg)";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var activeTab = document.querySelector(".faq-btn.active");
  var dropdownLabel = document.getElementById("dropdownLabel");

  // Page load → active tab no text show karvo
  if (activeTab) {
    dropdownLabel.textContent = activeTab.textContent;
  }

  // Click event → active change & label update
  document.querySelectorAll(".faq-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      document.querySelectorAll(".faq-btn").forEach(function (el) {
        el.classList.remove("active");
      });
      btn.classList.add("active");

      dropdownLabel.textContent = btn.textContent;

      document.getElementById("dropdownMenu").style.display = "none";
      document.getElementById("right-arrow").style.transform = "rotate(0deg)";
    });
  });
});

if (matchMedia) {
  const mq = window.matchMedia("(min-width: 741px)");
  mq.addListener(WidthChange);
  WidthChange(mq);
}

// media query change
function WidthChange(mq) {
  if(!mq.matches){
    function tab_toggle(item){
      item.setAttribute('role', 'button');
      item.addEventListener("click", () => {
        if(item.classList.contains('is_open')){
          item.classList.remove("is_open");
        }else{
          let tabs_button = document.querySelectorAll("[data-accodian-tragger]");
            tabs_button.forEach(b => {
              b.classList.remove("is_open"); 
              });
          item.classList.add("is_open");
        }
      }); 
    } 
    let tabs_acc  = document.querySelectorAll("[data-accodian-tragger]");
    tabs_acc.forEach(tab_toggle);
  }
}

//range-pdp
document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector(".zustand-bar");
  const items = document.querySelectorAll(".zustand-item");
  const activeLine = document.querySelector(".zustand-active-line");

  if (bar && items.length > 0 && activeLine) {
    const active = bar.querySelector(".zustand-item.active");

    if (active) {
      const first = items[0];
      const last = items[items.length - 1];

      const firstStart = first.offsetLeft;
      const lastEnd = last.offsetLeft + last.offsetWidth;
      const activeCenter = active.offsetLeft + active.offsetWidth / 2;

      if (active === first) {
        activeLine.style.left = firstStart + "px";
        activeLine.style.width = (lastEnd - firstStart) + "px";
      }
      else if (active === last) {
        activeLine.style.left = firstStart + "px";
        // activeLine.style.width = (lastEnd - firstStart) + "px";
      }
      else {
        activeLine.style.left = activeCenter + "px";
        activeLine.style.width = (lastEnd - activeCenter) + "px";
      }
    }
  }
});


// mega menu hover 
document.querySelectorAll('.header__linklist-item-button').forEach(item => {
  item.addEventListener('mouseenter', () => {
    const parentContainer = item.closest('.mega-menu');
    const buttonList = item.closest('.header__linklist-button');

    buttonList.querySelectorAll('.header__linklist-item-button').forEach(sibling => {
      sibling.classList.remove('active');
    });
    item.classList.add('active');

    const title = item.getAttribute('data-item-title');
    parentContainer.querySelectorAll('.mega-menu__list .header__linklist-item').forEach(menuItem => {
      menuItem.classList.remove('active');
      if (menuItem.getAttribute('data-item-title') === title) {
        menuItem.classList.add('active');
      }
    });
  });
});

//mobile page scroll hidden class
document.addEventListener("DOMContentLoaded", function() {
  const header = document.querySelector(".shopify-section--header");

  function isMobile() {
    return window.innerWidth <= 749;
  }

  if (header && isMobile()) {
    window.addEventListener("scroll", function() {
      if (window.scrollY > 50) {
        header.style.display = "none";
      } else {
        header.style.display = "block";
      }
    });
  }
});

const its_check = document.querySelectorAll('.team.swiper-slide') || null;
const its_check_sw = document.querySelector('.our-team [data-slider-options]') || null;
if(its_check.length > 0 && its_check_sw){
  const _swiprt_mai  = its_check_sw.swiper || false; 

  if (_swiprt_mai){
        its_check.forEach(function(item) {
            item.addEventListener('click', function () {
                const label = this.getAttribute('aria-label').split('/')[0] - 1;
                console.log("label",label)
                if(label){
                  _swiprt_mai.slideTo(label,200,false);
                }
            });
        });
  }
}




//info box
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openInfo");
  const closeBtn = document.getElementById("closeInfo");
  const infoBox = document.getElementById("infoBox");

  if (openBtn && closeBtn && infoBox) {
    openBtn.addEventListener("click", () => {
      infoBox.classList.add("show");
      openBtn.style.display = "none";  
    });

    closeBtn.addEventListener("click", () => {
      infoBox.classList.remove("show");
      openBtn.style.display = "flex";  
    });
  }
});

//scroll top
const btn = document.querySelector('.scroll_top');

window.addEventListener('scroll', () => {
  if (window.scrollY > 300) {
    btn.classList.add('show');
  } else {
    btn.classList.remove('show');
  }
});

btn.addEventListener('click', (e) => {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});
